const init = () => {};
document.addEventListener('DOMContentLoaded', function () {
	jQuery(document).ready(function ($) {
		$('.slide-list').slick({
			lazyLoad: 'ondemand',
			dots: false,
			infinite: true,
			arrows: true,
			speed: 500,
			slidesToShow: 1,
			slidesToScroll: 1,
			swipe: false,
			draggable: false,
			cssEase: 'cubic-bezier(0.8, 0.8, 0.8, 1)', // Smooth ease transition
			ltl: true,
		});
		var $menuItems = $('.slider-menus li');
		$menuItems.each(function (index) {
			var slideNumber = index + 1; // Slide number starts from 1, not 0
			$(this).attr('data-slide', slideNumber); // Add data-slide to the <li> tag
		});
		// When a menu item is clicked, go to the corresponding slide
		$('.slider-menus li').on('click', function () {
			var slideIndex = $(this).data('slide'); // subtract 1 since Slick is 0-indexed
			$('.slide-list').slick('slickGoTo', slideIndex);
		});
	});
});
// Exports
export { init };
